import { FormEvent, useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Page from '../../../components/atoms/page';
import AddVehicleType from './addVehicleType';

const TryVin = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeVin = (searchParams.get('vin') ?? '').trim().toUpperCase();
  const [vinInput, setVinInput] = useState(activeVin);
  const normalizedVin = vinInput.trim().toUpperCase();
  const invalidLength = normalizedVin.length > 0 && normalizedVin.length !== 17;

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (normalizedVin.length !== 17) return;
    setSearchParams({ vin: normalizedVin });
  };

  const handleClear = () => {
    setVinInput('');
    setSearchParams({});
  };

  return (
    <>
      <Page title="Try VIN">
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, px: 3, py: 2 }}
        >
          <TextField
            label="VIN"
            value={vinInput}
            onChange={(event) => setVinInput(event.target.value.toUpperCase())}
            size="small"
            error={invalidLength}
            helperText={`${normalizedVin.length}/17 characters`}
            inputProps={{ maxLength: 17, style: { fontFamily: 'monospace', letterSpacing: 2 } }}
            sx={{ minWidth: 320 }}
          />
          <Button type="submit" variant="contained" disabled={normalizedVin.length !== 17} sx={{ mt: 0.25 }}>
            Try VIN
          </Button>
          {activeVin && (
            <Button variant="outlined" onClick={handleClear} sx={{ mt: 0.25 }}>
              Clear
            </Button>
          )}
        </Box>
        {!activeVin && (
          <Typography variant="body2" color="text.secondary" sx={{ px: 3, pb: 2 }}>
            Enter a 17 character VIN to check whether its make, model, variant and VIN pattern are configured.
          </Typography>
        )}
      </Page>
      {activeVin.length === 17 && <AddVehicleType key={activeVin} embedded />}
    </>
  );
};

export default TryVin;
